export default __webpack_public_path__ + "static/wundar-0b0cadf0604e21fa42d4b874cd371b8f.png";